import tinycolor from 'tinycolor2';

/**
 * Returns the most accessible text color for a given background, following WCAG 4.5:1.
 * Falls back to a darkened shade of the background when primaryHex doesn't meet contrast.
 */
export function bestTextColor(bgHex, primaryHex) {
    const bg = tinycolor(bgHex);
    if (bg.getLuminance() < 0.5) return '#ffffff';
    if (tinycolor.readability(bgHex, primaryHex) >= 4.5) return primaryHex;
    // binary-search a darkened shade of bg that meets 4.5:1 contrast
    const hsl = bg.toHsl();
    let lo = 0, hi = hsl.l;
    for (let i = 0; i < 12; i++) {
        const mid = (lo + hi) / 2;
        const candidate = tinycolor({ h: hsl.h, s: hsl.s, l: mid }).toHexString();
        if (tinycolor.readability(bgHex, candidate) >= 4.5) lo = mid;
        else hi = mid;
    }
    return tinycolor({ h: hsl.h, s: hsl.s, l: lo }).toHexString();
}
